








import { Component, Mixins, Watch } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';
import { OverviewLayoutITF, ViewFilter } from '@/interfaces';
import { State, Getter, Mutation } from 'vuex-class';

@Component
export default class SitesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
}
